import { render, staticRenderFns } from "./ListUnitiesAndProfiles.vue?vue&type=template&id=55f48730&scoped=true"
import script from "./ListUnitiesAndProfiles.vue?vue&type=script&lang=js"
export * from "./ListUnitiesAndProfiles.vue?vue&type=script&lang=js"
import style0 from "./ListUnitiesAndProfiles.vue?vue&type=style&index=0&id=55f48730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f48730",
  null
  
)

export default component.exports